import { analytics } from "../analytics";

export default {
    methods: {
        refresh() {
            window.location.reload();
        },

        handleManual() {
            this.showManual = true;
            this.loading = true;

            // LogRocket tracking
            window.LogRocket?.track?.('manual_bank_opened', {
                loan_id: this.loan?.id ?? null,
                source: 'connect_bank_accounts'
            });

            analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'verify-account').handleOpenManualAccountModal({
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user_id ?? this.user?.id ?? null,
                page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
            });
        },

        handleCloseManual() {
            this.showManual = false;
            this.loading = false;
            analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handleCloseManualAccountModal({
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user_id ?? this.user?.id ?? null,
                page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
            });
        },

        plaidChangeBank() {
            this.handlePlaid(true);
        },

        handlePlaid(changeBank = false) {

            // LogRocket tracking
            window.LogRocket?.track?.('plaid_initiated', {
                loan_id: this.loan?.id ?? null,
                change_bank: changeBank
            });

            analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handlePlaid({
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user_id ?? this.user?.id ?? null,
                page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                change_bank: changeBank,
            });
            // debugger;
            let url = `/signup/welcome/${this.loan.id}`;

            if (changeBank === true) {
                url = `/account/change-bank/plaid/${this.loan.id}`;
            }

            this.loading = true;
            this.plaid = window.Plaid.create({
                token: this.plaidLinkToken,
                onSuccess: (public_token, metadata) => {
                    this.proceeding = true;
                    console.log('plaid success', public_token, metadata);

                    // LogRocket tracking
                    window.LogRocket?.track?.('plaid_success', {
                        bank: metadata.institution?.name,
                        accounts_connected: metadata.accounts?.length,
                        loan_id: this.loan?.id ?? null
                    });

                    analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handlePlaidSuccess({
                        loan_id: this.loan?.id ?? null,
                        loan_status: this.loan?.status ?? null,
                        user_id: this.loan?.user_id ?? this.user?.id ?? null,
                        page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                    });

                    this.$http
                        .post(url, {
                            public_token,
                            institution: metadata.institution,
                            accounts: metadata.accounts,
                            onboarding_attempt: true,
                        })
                        .then(() => {
                            this.startPollingEdgeStatus()
                        }).catch(error => {
                            this.loading = false;
                            this.proceeding = false;
                            console.log(error);
                            
                            if (error.response && error.response.status === 422 && error.response.data?.onboarding_way) {
                                this.showErrorPopup = true;
                                this.errorMessage = error.response.data.onboarding_way;
                            }
                        });
                },
                onEvent: (event, metadata) => {
                    if (event == 'ERROR') {
                        window.Bugsnag.notify('fail Verify: ' + JSON.stringify({
                            error: metadata.error_code + ' (' + metadata.error_message + ')',
                            loan_id: this.loan?.id,
                            user_id: this.user?.id,
                        }));

                        // LogRocket tracking
                        window.LogRocket?.track?.('plaid_error', {
                            error_code: metadata.error_code,
                            bank: metadata.institution?.name,
                            loan_id: this.loan?.id ?? null
                        });

                        analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handlePlaidExitError({
                            loan_id: this.loan?.id ?? null,
                            loan_status: this.loan?.status ?? null,
                            user_id: this.loan?.user_id ?? this.user?.id ?? null,
                            page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                            error: metadata.error_code + ' (' + metadata.error_message + ')',
                        });
                    }

                    // Track bank selection
                    if (event == 'SELECT_INSTITUTION') {
                        window.LogRocket?.track?.('plaid_bank_selected', {
                            bank: metadata.institution_name,
                            loan_id: this.loan?.id ?? null
                        });
                    }

                    window.axios?.post('/api/plaid/link-events', {
                        event_name: event,
                        loan_id: this.loan?.id ?? null,
                        institution_name: metadata.institution_name ?? metadata.institution?.name ?? null,
                        error_type: metadata.error_type ?? null,
                        error_code: metadata.error_code ?? null,
                        error_message: metadata.error_message ?? null,
                        link_session_id: metadata.link_session_id ?? null,
                        request_id: metadata.request_id ?? null,
                        exit_status: metadata.exit_status ?? null,
                        metadata: metadata,
                        event_time: new Date().toISOString(),
                    }).catch(() => {});
                },
                onExit: (error, metadata) => {
                    this.loading = false;

                    // LogRocket tracking
                    window.LogRocket?.track?.('plaid_exit', {
                        bank: metadata.institution?.name,
                        completed: metadata.status === 'connected',
                        error_code: error?.error_code,
                        loan_id: this.loan?.id ?? null
                    });

                    analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handlePlaidExit({
                        loan_id: this.loan?.id ?? null,
                        loan_status: this.loan?.status ?? null,
                        user_id: this.loan?.user_id ?? this.user?.id ?? null,
                        page_name: 'verify-bank-account',
                        error: error,
                        status: metadata.status,
                        link_session_id: metadata.link_session_id,
                        plaid_request_id: metadata.request_id,
                    });
                },
            });
            this.plaid.open();
        },

        /**
         * @param type
         * @param payload
         */
        onMxEvent(type, payload) {
            switch (type) {
                case "mx/connect/memberError":
                case "mx/connect/createMemberError":
                    if (
                        payload.hasOwnProperty("member") &&
                        payload.member.hasOwnProperty("connection_status") &&
                        payload.member.connection_status === 2
                    ) {
                        this.mxConnectDenied(payload);
                    } else {
                        window.Bugsnag.notify(new Error(`${type}: ${JSON.stringify(payload)}`));
                    }

                    analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handleMxError({
                        loan_id: this.loan?.id ?? null,
                        loan_status: this.loan?.status ?? null,
                        user_id: this.loan?.user_id ?? this.user?.id ?? null,
                        page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                        payload: payload,
                    });

                    break;
                case "mx/connect/oauthError":
                    if (payload.error_reason === "DENIED") {
                        this.mxConnectDenied(payload);
                    } else {
                        window.Bugsnag.notify(new Error(`${type}: ${JSON.stringify(payload)}`));
                    }

                    analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handleMxOauthError({
                        loan_id: this.loan?.id ?? null,
                        loan_status: this.loan?.status ?? null,
                        user_id: this.loan?.user_id ?? this.user?.id ?? null,
                        page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                        payload: payload,
                    });

                    break;
                case "mx/connect/selectedInstitution":
                    this.institution_id = payload.guid;
                    this.institution_code = payload.code;
                    analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handleMxSelectInstitution({
                        loan_id: this.loan?.id ?? null,
                        loan_status: this.loan?.status ?? null,
                        user_id: this.loan?.user_id ?? this.user?.id ?? null,
                        page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                        institution_id: payload.guid,
                        institution_code: payload.code,
                    });
                    break;
                case "mx/connect/memberConnected":
                    // return this.connected(payload);
                    break;
                case "mx/connect/connected/primaryAction":
                    return this.proceed();
                case "mx/connect/memberStatusUpdate":
                    if (payload.connection_status === 6) {
                        analytics.dinamicPageEvents(this.gEventType ?? 'MarketPlaceSignUp', this.gTagPageName ?? 'VERIFY_ACCOUNT').handleMxConnected({
                            loan_id: this.loan?.id ?? null,
                            loan_status: this.loan?.status ?? null,
                            user_id: this.loan?.user_id ?? this.user?.id ?? null,
                            page_name: this.gTagPageName ?? 'VERIFY_ACCOUNT',
                        });
                        this.mxConnected(payload);
                    }
            }
        },

        /**
         * TriggeredBankChange after they successfully connect their bank to MX.
         *
         * @param payload
         * @return {void}
         */
        mxConnected(payload) {
            this.$http.post(`/signup/verify-bank-account/mx/${this.loan.id}`, {
                ...payload,
                ...{
                    institution_guid: this.institution_id,
                    institution_code: this.institution_code,
                    onboarding_attempt: true,
                },
            });
        },

        /**
         * TriggeredBankChange after they successfully connect their bank to MX.
         *
         * @param payload
         * @return {void}
         */
        mxConnectDenied(payload) {
            this.$http.post(`/signup/verify-bank-account/${this.loan.id}/denied`).then(() => this.proceed());
        },

        /**
         * TriggeredBankChange after they've connected, and click "Continue."
         *
         * @return {void}
         */
         proceed() {
            this.proceeding = true;
        },

        continue() {
            // to don't show user wrong page
            setTimeout(() => {
                this.loading = false;
            })
            window.location.reload();
        },

        startPollingEdgeStatus() {
            this.interval = setInterval(this.checkEdgeReport, 5000);
        },
        
        

        async checkEdgeReport() {
            this.attempts++;

            if (this.attempts >= this.maxAttempts) {
                clearInterval(this.interval)
                this.continue()
            }

            try {
                const response = await fetch(`/signup/edge-report-ready/${this.loan.id}`);
                const data = await response.json();

                if (data.edge_report_ready) {
                    this.continue()
                }
            } catch (error) {
                console.error('Polling error:', error);
            }
        },

        /**
         * Close the error popup
         */
        closeErrorPopup() {
            this.showErrorPopup = false;
            this.errorMessage = '';
            this.refresh();
        },
    },
}
